import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import TitledComponent from 'components/TitledComponent';
import DatePicker from "components/DatePicker";
import clsx from "clsx";

const style = theme => ({
	titleRoot: {
		marginLeft: theme.spacing(2),
		marginTop: theme.spacing(2)
	},
	datePickerRoot: {
		width: 238
	}
})

function FormDateElement({
	classes,
	formikProps,
	id,
	title,
	required,
	minDate = new Date(),
	onChange,
	disabled = false,
	tooltip = null,
	hideTooltip = true
}) {
	let label = title;
	if (required) label += '*'

	return (
		<TitledComponent
			className={classes.titleRoot}
			title={label}
		>
			<DatePicker
				formikProps={formikProps}
				id={id}
				onChange={onChange}
				minDate={minDate}
				disabled={disabled}
				className={clsx(classes.datePickerRoot)}
				tooltip={tooltip}
				hideTooltip={hideTooltip}
			/>
		</TitledComponent>
	)
}

FormDateElement.propTypes = {
	classes: PropTypes.any,
	id: PropTypes.string,
	title: PropTypes.string,
	formikProps: PropTypes.object,
}

FormDateElement.defaultProps = {
}

export default withStyles(style)(FormDateElement);